import { render, staticRenderFns } from "./BottomBanner.vue?vue&type=template&id=57f04684"
import script from "./BottomBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomBanner.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppDownloadBanner: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/AppDownloadBanner.vue').default,RegistrationBanner: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/RegistrationBanner.vue').default})
